import { TWebsocketFilepath, TWebsocketHostname, TWebsocketProjectpath, TWebsocketScriptSettings } from "../../../../interface/interfaces";

const hasExactProperties = <T extends Record<string, unknown>>(
    obj: unknown,
    keys: (keyof T)[]
): obj is T => {
    return (
        typeof obj === "object" &&
        obj !== null &&
        Object.keys(obj).length === keys.length && // Proverava TAČAN broj property-ja
        keys.every((key) => Object.hasOwn(obj, key) && typeof (obj as any)[key] === "string")
    );
};


export const isTWebsocketHostname = (obj: unknown): obj is TWebsocketHostname => {
    return hasExactProperties<TWebsocketHostname>(obj, ["osUserName", "osHostName"]);
};

export const isTWebsocketFilepath = (obj: unknown): obj is TWebsocketFilepath => {
    return hasExactProperties<TWebsocketFilepath>(obj, ["filePath", "tool"]);
};

export const isTWebsocketProjectpath = (obj: unknown): obj is TWebsocketProjectpath => {
    return hasExactProperties<TWebsocketProjectpath>(obj, ["projectPath"]);
};

export const isTWebsocketScriptSettings = (obj: unknown): obj is TWebsocketScriptSettings => {
    return hasExactProperties<TWebsocketScriptSettings>(obj, ["script", "localVersion", "status"]);
};